import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import { router } from "../router/index";
import {
  setLocalStorage,
  clearLocalStorage,
  setLocalStorageNewTokenKey,
  setLocalStorageExpiredStatus,
} from "../js/oauth";
import { setSnackBarInfo } from "../js/common_function";

const AXIOS = axios.create({
  baseURL: "/api",
  timeout: 10000,
});

function allUpdateUser(results) {
  return AXIOS({
    url: "/userMng/allUpdateUser",
    method: "post",
    data: {
      results: results,
    },
    headers: {
      "token-key": localStorage.getItem("token-key"),
    },
  });
}

function allUserDelete(selected) {
  return AXIOS({
    url: "/userMng/allUserDelete",
    method: "post",
    data: {
      selected: selected,
    },
    headers: {
      "token-key": localStorage.getItem("token-key"),
    },
  });
}

function failAccountReset(selected) {
  return AXIOS({
    url: "/userMng/failAccountReset",
    method: "post",
    data: {
      selected: selected,
    },
    headers: {
      "token-key": localStorage.getItem("token-key"),
    },
  });
}

function pwReset(selected) {
  return AXIOS({
    url: "/userMng/pwReset",
    method: "post",
    data: {
      selected: selected,
    },
    headers: {
      "token-key": localStorage.getItem("token-key"),
    },
  });
}

function isOkayCheck(member) {
  return AXIOS({
    url: "/userMng/isOkayCheck",
    method: "post",
    data: {
      password: member.password,
    },
    headers: {
      "token-key": localStorage.getItem("token-key"),
      "token-setup": localStorage.getItem("token-setup"),
    },
  });
}
function getRepreSeq() {
  return AXIOS({
    url: "/getRepreSeq",
    method: "post",
    data: {},
    headers: {
      "token-key": localStorage.getItem("token-key"),
    },
  });
}
function getSitemapPhoto() {
  return AXIOS({
    url: "/getSitemapPhoto",
    method: "post",
    data: {},
    headers: {
      "token-key": localStorage.getItem("token-key"),
    },
  });
}
function getRepresentPhoto(num) {
  return AXIOS({
    url: "/getRepresentPhoto",
    method: "post",
    data: {
      id: num,
    },
    headers: {
      "token-key": localStorage.getItem("token-key"),
    },
  });
}
function setRepresentPhoto(representPho, num, start, end) {
  return AXIOS({
    url: "/setRepresentPhoto",
    method: "post",
    data: {
      representPho: representPho,
      id: num,
      start: start,
      end: end,
    },
    headers: {
      "token-key": localStorage.getItem("token-key"),
    },
  });
}
function setSitemapPhoto(representPho, num) {
  return AXIOS({
    url: "/setSitemapPhoto",
    method: "post",
    data: {
      representPho: representPho,
      id: num,
    },
    headers: {
      "token-key": localStorage.getItem("token-key"),
    },
  });
}
function setLastSeq(num) {
  return AXIOS({
    url: "/setLastSeq",
    method: "post",
    data: {
      id: num,
    },
    headers: {
      "token-key": localStorage.getItem("token-key"),
    },
  });
}

const state = {
  scrollXY: {
    top: "",
    left: "",
  },
  loadingState: false,
  spinnerLoading: true,
  snackbar: {
    open: false,
    text: "",
    location: "top",
    time: 2000,
  },

  errorMessage: "잘못된 요청입니다.",
  warningMsg: "마이페이지 접근을 위한 추가 인증입니다.",
  isOkayCheck: false,

  // ============ Rules ============ //
  emailRules: [
    (v) => !!v || "이메일을 작성해주세요.",
    (v) => /.+@.+\..+/.test(v) || "이메일 형식으로 작성해주세요.",
    (v) => v.search(/\s/) === -1 || "공백을 제거해주세요!",
  ],
  nameRules: [
    (v) => !!v || "이름을 작성해주세요.",
    (v) => v.search(/\s/) === -1 || "공백을 제거해주세요!",
    (value) => (value && value.length >= 2) || "Min 2 characters",
  ],
  passwordRules: [
    (v) => !!v || "비밀번호를 작성해주세요",
    (v) => v.search(/\s/) === -1 || "공백을 제거해주세요!",
    (value) => (value && value.length >= 4) || "Min 4 characters",
  ],
  inputRules: [
    (value) => !!value || "Required.",
    (value) => (value && value.length >= 3) || "Min 3 characters",
  ],
};

const getters = {
  isOkayCheck(state) {
    return state.isOkayCheck;
  },
  isSpinnerLoading(state) {
    return state.spinnerLoading;
  },
};

const mutations = {
  IS_SCROLLXY(state, xy) {
    state.scrollXY.top = xy.top;
  },
  IS_OKAY_CHECK(state) {
    state.isOkayCheck = true;
    state.warningMsg = "마이페이지 접근을 위한 추가 인증입니다.";
  },
  FAIL_IS_OKAY_CHECK(state) {
    state.isOkayCheck = false;
    state.warningMsg = "비밀번호가 틀립니다.";
  },

  // START_LOADING(state) {
  //   state.loadingState = true;
  // },
  // END_LOADING(state) {
  //   state.loadingState = false;
  // },
  SET_SNACKBAR(state, snackbarInfo) {
    state.snackbar.open = true;
    state.snackbar.text = snackbarInfo.text;
    state.snackbar.time = snackbarInfo.time;
  },
  PUSH_ERROR_PAGE(state) {
    state.errorMessage = "잘못된 요청입니다.";
    router.push("/error");
  },
  START_SPINNER(state) {
    state.spinnerLoading = true;
  },
  END_SPINNER(state) {
    state.spinnerLoading = false;
  },
};

const actions = {
  async ALL_UPDATE_USER(context, results) {
    try {
      const response = await allUpdateUser(results);
      context.commit("SET_SNACKBAR", setSnackBarInfo("수정 되었습니다."));
      return response;
    } catch (e) {
      console.log(e);
      context.commit("SET_SNACKBAR", setSnackBarInfo("수정 실패."));
    }
  },
  async ALL_USER_DELETE(context, selected) {
    try {
      const response = await allUserDelete(selected);
      context.commit(
        "SET_SNACKBAR",
        setSnackBarInfo("선택 항목 삭제 되었습니다.")
      );
      return response;
    } catch (e) {
      console.log(e);
      context.commit("SET_SNACKBAR", setSnackBarInfo("수정 실패."));
    }
  },
  async FAIL_ACCOUNT_RESET(context, selected) {
    try {
      const response = await failAccountReset(selected);
      context.commit("SET_SNACKBAR", setSnackBarInfo("초기화 되었습니다."));
      return response;
    } catch (e) {
      console.log(e);
      context.commit("SET_SNACKBAR", setSnackBarInfo("초기화 실패."));
    }
  },
  async PW_RESET(context, selected) {
    try {
      const response = await pwReset(selected);
      context.commit(
        "SET_SNACKBAR",
        setSnackBarInfo(
          response.data.newPassword + "로 비밀번호 초기화 되었습니다.",
          20000
        )
      );
      return response;
    } catch (e) {
      console.log(e);
      context.commit("SET_SNACKBAR", setSnackBarInfo("초기화 실패."));
    }
  },
  async IS_OKAY_CHECK(context, member) {
    try {
      const response = await isOkayCheck(member);
      // if(response.data.)
      if (response.data.statusCode === 200) {
        context.commit("IS_OKAY_CHECK");
        context.commit("SET_SNACKBAR", setSnackBarInfo("확인 되었습니다."));
        router.push("/MyPage");
      } else {
        context.commit("FAIL_IS_OKAY_CHECK");
        context.commit("SET_SNACKBAR", setSnackBarInfo("확인 실패."));
      }
      return response;
    } catch (e) {
      console.log(e);
      context.commit("SET_SNACKBAR", setSnackBarInfo("서버 에러."));
    }
  },
  async IS_REPRE_SEQ(context) {
    try {
      const response = await getRepreSeq();
      // console.log(response);
      if (response.status === 200) {
        // var file = response.data[0].representPhoto;
        // const change_size_photo_response = await change_size_photo(file);
        // console.log(change_size_photo_response);
        // const response_inner = await setRepresentPhoto(contents);
        return response;
      } else {
        context.commit("SET_SNACKBAR", setSnackBarInfo("확인 실패."));
      }
    } catch (e) {
      console.log(e);
      context.commit(
        "SET_SNACKBAR",
        setSnackBarInfo("서버 에러 IS_CHANGE_REPRESENT_PHOTO.")
      );
    }
  },
  async IS_SITEMAP_PHOTO(context) {
    try {
      const response = await getSitemapPhoto();
      // console.log(response);
      if (response.status === 200) {
        // var file = response.data[0].representPhoto;
        // const change_size_photo_response = await change_size_photo(file);
        // console.log(change_size_photo_response);
        // const response_inner = await setRepresentPhoto(contents);
        return response;
      } else {
        context.commit("SET_SNACKBAR", setSnackBarInfo("확인 실패."));
      }
    } catch (e) {
      console.log(e);
      context.commit(
        "SET_SNACKBAR",
        setSnackBarInfo("서버 에러 IS_CHANGE_REPRESENT_PHOTO.")
      );
    }
  },
  async IS_CHANGE_REPRESENT_PHOTO(context, num) {
    try {
      const response = await getRepresentPhoto(num);
      // console.log(response);
      if (response.status === 200) {
        // var file = response.data[0].representPhoto;
        // const change_size_photo_response = await change_size_photo(file);
        // console.log(change_size_photo_response);
        // const response_inner = await setRepresentPhoto(contents);
        return response;
      } else {
        context.commit("SET_SNACKBAR", setSnackBarInfo("확인 실패."));
        return response;
      }
    } catch (e) {
      console.log(e);
      context.commit(
        "SET_SNACKBAR",
        setSnackBarInfo("서버 에러 IS_CHANGE_REPRESENT_PHOTO.")
      );
    }
  },
  async IS_CREATE_AND_SET_IMAGE(context, contents) {
    try {
      const fr = new FileReader();
      // console.log(file);
      const image = new Image();
      image.src = contents.file;
      image.onload = () => {
        const $canvas = document.createElement(`canvas`);
        const ctx = $canvas.getContext(`2d`);

        $canvas.width = image.width;
        $canvas.height = image.height;
        ctx.drawImage(image, 0, 0);

        // 용량이 줄어든 base64 이미지
        // console.log($canvas.toDataURL(`image/jpeg`, 0.5));
        const representPho = $canvas.toDataURL(`image/jpeg`, 0.3);
        // console.log(representPho);
        setRepresentPhoto(
          representPho,
          contents.num,
          contents.start,
          contents.end
        );
        if (contents.num === contents.end) {
          // console.log("success", contents.num);
          setLastSeq(contents.num);
        }
      };
    } catch (e) {
      console.log(e);
      context.commit(
        "SET_SNACKBAR",
        setSnackBarInfo("서버 에러 IS_CHANGE_REPRESENT_PHOTO.")
      );
    }
  },
  async IS_CREATE_AND_SET_IMAGE_SITEMAP(context, contents) {
    try {
      console.log(contents);
      const fr = new FileReader();
      const image = new Image();
      image.src = contents.contentsHTML;
      image.onload = () => {
        const $canvas = document.createElement(`canvas`);
        const ctx = $canvas.getContext(`2d`);

        $canvas.width = image.width;
        $canvas.height = image.height;

        ctx.drawImage(image, 0, 0);

        // 용량이 줄어든 base64 이미지
        // console.log($canvas.toDataURL(`image/jpeg`, 0.5));
        const representPho = $canvas.toDataURL(`image/jpeg`, 0.3);
        // console.log(representPho);
        setSitemapPhoto(representPho, contents.id);
      };
    } catch (e) {
      console.log(e);
      context.commit(
        "SET_SNACKBAR",
        setSnackBarInfo("서버 에러 IS_CREATE_AND_SET_IMAGE_SITEMAP.")
      );
    }
  },
};

export default {
  mutations,
  state,
  actions,
  getters,
};
